<template>
	<router-view />
</template>

<script>
export default {
	methods: {
		setTeam(teamKey) {
			this.$store.dispatch("setActiveTeam", teamKey)
		},
	},
	mounted() {
		this.setTeam(this.$route.params.teamKey)
	},
	beforeRouteUpdate(to, from, next) {
		this.setTeam(to.params.teamKey)
		next()
	},
}
</script>
